module.exports = __webpack_public_path__ + "img/zu6.0e68a8fd.png";